import { render, staticRenderFns } from "./FormControlModulestructureDateFormat.vue?vue&type=template&id=7c423883"
import script from "./FormControlModulestructureDateFormat.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlModulestructureDateFormat.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports